import { AutoLink, type AutoLinkProps } from '@betterment/js-runtime';
import { IconLink, type IconLinkProps } from '@betterment/samba-react';

export type SambaAutoLinkProps = Omit<AutoLinkProps & IconLinkProps, 'children'>;

export const SambaIconAutoLink: React.FC<SambaAutoLinkProps> = ({
  to,
  prefetch,
  preventScrollReset,
  reloadDocument,
  viewTransition,
  ...linkProps
}) => {
  const reactRouterProps = { prefetch, preventScrollReset, reloadDocument, viewTransition };
  return (
    <IconLink {...linkProps} asChild={true}>
      <AutoLink to={to} {...reactRouterProps}>
        &nbsp;
      </AutoLink>
    </IconLink>
  );
};
